
import { helpers, required, requiredIf, minValue, maxValue } from "@vuelidate/validators";

import { Medication } from "@/entities/conditions";
import { maxDecimalPrecisionValidator } from "@/utils/validators";

export default (medication: Medication | null) => ({
    dosage: {
        required: helpers.withMessage("The Amount field is required.",
            required),
        maxValue: helpers.withMessage("The Amount field must be 9999.9999 or less.",
            maxValue(9999.9999)),
        minValue: helpers.withMessage("The Amount field must be 0.001 or more.",
            minValue(0.001)),
        decimalPrecision: maxDecimalPrecisionValidator(6, "Amount"),
    },
    dosageUnits: {
        required: helpers.withMessage("The Dosage units field is required.",
            required),
    },
    frequencyUnits: {
        required: helpers.withMessage("The period field is required.",
            required),
    },
    frequency: {
        requiredIf: helpers.withMessage("The How often field is required.",
            requiredIf(() => medication?.frequencyUnits !== "As Required")),
        maxValue: helpers.withMessage("The How often field must be 999 or less.",
            maxValue(999)),
        minValue: helpers.withMessage("The How often field must be 0 or more.",
            minValue(0)),
        integer: helpers.withMessage("The How often field must be a whole number.", value => Number.isInteger(value)),
    },
});
